import React from 'react';
import evLogo from './img/evLogo.svg';
import truckLogo from './img/truckLogo.svg';
import hybridLogo from './img/hybridLogo.svg';

const EvIcon = (props) => {
  const { assetType } = props;
  const indicator = (value) => {
        switch (value) {
        case 'Rail':
            return <img loading="lazy" src={truckLogo} alt="indication-icon" />;
        case 'Road':
            return <img loading="lazy" src={truckLogo} alt="indication-icon" />;
        case 'EV1':
            return <img loading="lazy" src={evLogo} alt="indication-icon" />;
        case 'EV2':
            return <img loading="lazy" src={evLogo} alt="indication-icon" />;
        case 'Hybrid':
            return <img loading="lazy" src={hybridLogo} alt="indication-icon" />;
        default:
            return null;
        }
  };
  return (
    <div>
        {indicator(assetType)}
    </div>
  );
};

export default EvIcon;
